import script from "./AccessRolesManagementTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessRolesManagementTable.vue?vue&type=script&setup=true&lang=js"

import "./AccessRolesManagementTable.vue?vue&type=style&index=0&id=35ae16d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35ae16d6"]])

export default __exports__